import { Directive, ElementRef, Renderer2 } from "@angular/core";

@Directive({
	selector: "[appTextEnd]",
})
export class TextEndDirective {
	constructor(
		private el: ElementRef,
		private renderer: Renderer2
	) {
		this.renderer.addClass(this.el.nativeElement, "text-end");
	}
}
